import { CONTEST_RULES_VERSION } from "constants/contestRulesContent";

const KEY_PREFIX = "alphasniper_contest_rules_accepted";

function storageKey(clientId) {
  return `${KEY_PREFIX}_${CONTEST_RULES_VERSION}_${clientId}`;
}

export function hasAcceptedContestRules(clientId) {
  if (!clientId) return true;
  try {
    return localStorage.getItem(storageKey(clientId)) === "1";
  } catch {
    return false;
  }
}

export function saveContestRulesAcceptance(clientId) {
  if (!clientId) return;
  try {
    localStorage.setItem(storageKey(clientId), "1");
  } catch {
    /* ignore */
  }
}
